import { Environment } from 'constants/envConfig';

interface ISentryEnvConfig {
    dsn: string;
    tracesSampleRate: number;
}

// Set tracesSampleRate to 1.0 to capture 100%
// of transactions for performance monitoring.
// We recommend adjusting this value in production
const sentryEnvConfig: Record<Partial<Environment>, ISentryEnvConfig> = {
    [Environment.production]: {
        dsn: 'https://ab5e6e11e61d4343ac2f5ebadef3b79f@o1052353.ingest.sentry.io/6145005',
        tracesSampleRate: 0.25,
    },
    [Environment.integrations]: {
        dsn: 'https://18dab223936141c6acc68867134f43f5@o1052353.ingest.sentry.io/6145005',
        tracesSampleRate: 0.25,
    },
    [Environment.staging]: {
        dsn: 'https://960173c92c504ec78b922c855627a8bb@o1052353.ingest.sentry.io/6145005',
        tracesSampleRate: 0.25,
    },
    [Environment.demo]: {
        dsn: 'https://4659cfc152714f11a08b0712c1bdbb22@o1052353.ingest.sentry.io/6145005',
        tracesSampleRate: 0.25,
    },
    [Environment.local]: {
        dsn: 'https://75c4770edfec4b36ab5d56e6a5c02f5b@o1052353.ingest.sentry.io/6145005',
        tracesSampleRate: 0.25,
    },
};

export const getDsnByEnv = (env: Environment): ISentryEnvConfig => sentryEnvConfig[env];
